
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box } from '@mui/material'
//import Sidebar from '../../components/Sidebar'
import Sidebar from '../../components/layout/Sidebar'

export const Home = () => {
  const navigate = useNavigate()

  
  useEffect(() => {
    if (!localStorage.getItem('AccessToken')) {
      navigate('/login')
    }
  }, [navigate])

  return (
    <Box sx={{}}>
      <Sidebar
        // handleDrawerClose={() => handleDrawerClose}
        // open={open}
      />
    </Box>
  )
}
